export const blueCheckboxCardClass = 'has-[:checked]:border-teamcare-blue has-[:checked]:bg-blue-50 has-[:checked]:text-teamcare-blue';

export const blueCheckboxClass = '[--chkbg:theme(colors.teamcare.blue)] checked:border-teamcare-blue';

export const choiceBtnSelected = 'bg-blue-50 border-teamcare-blue text-teamcare-blue hover:bg-blue-50 hover:border-teamcare-blue hover:text-teamcare-blue';

export const choiceBtnUnselected = 'bg-white border-gray-200 text-gray-800 hover:bg-white hover:border-gray-200 hover:text-gray-800';
